// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var $$Set = require("bs-platform/lib/js/set.js");
var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Model = require("./model");
var React = require("react");
var Slugify = require("./slugify");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var SortEnSeance = require("./sortEnSeance");
var MaterialUIIcons = require("bs-material-ui-icons/lib/js/src/MaterialUIIcons.js");
var DiscussionLayout = require("./discussionLayout");

var compare = Caml_obj.caml_compare;

var StringsSetItem = /* module */[/* compare */compare];

var StringsSet = $$Set.Make(StringsSetItem);

var component = ReasonReact.statelessComponent("DiscussionIndex");

function make(discussion, onNavigateToAmendement, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      return ReasonReact.element(/* None */0, /* None */0, DiscussionLayout.make(discussion, onNavigateToAmendement, /* array */[
                      ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h1"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Display2 */2], /* array */[Model.ste(discussion[/* titre */8])])),
                      $$Array.map((function (division) {
                              return React.createElement("section", {
                                          key: division[/* place */0],
                                          id: Curry._1(Slugify.slugify, division[/* place */0])
                                        }, ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* Some */[/* Center */2], /* None */0, /* None */0, /* Some */["h2"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Display1 */3], /* array */[Model.ste(division[/* place */0])])), $$Array.map((function (amendementWrapper) {
                                                var hash = Curry._1(Slugify.slugify, amendementWrapper[/* numero */11]);
                                                var match = amendementWrapper[/* amendement */1];
                                                var tmp;
                                                if (match) {
                                                  var amendement = match[0];
                                                  tmp = React.createElement("a", {
                                                        href: "tout#" + hash,
                                                        onClick: (function ($$event) {
                                                            $$event.preventDefault();
                                                            $$event.stopPropagation();
                                                            return Curry._1(onNavigateToAmendement, amendement[/* numeroReference */11]);
                                                          })
                                                      }, ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h4"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste("Amendement " + amendement[/* numeroLong */10])])));
                                                } else {
                                                  tmp = ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h4"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste("Amendement " + amendementWrapper[/* numero */11])]));
                                                }
                                                var match$1 = discussion[/* numeroProchainADiscuter */5];
                                                return React.createElement("article", {
                                                            key: amendementWrapper[/* numero */11]
                                                          }, tmp, match$1 && match$1[0] === amendementWrapper[/* numero */11] ? React.createElement("span", {
                                                                  style: {
                                                                    color: "orange"
                                                                  }
                                                                }, ReasonReact.element(/* None */0, /* None */0, MaterialUIIcons.Whatshot[/* make */0](/* array */[]))) : null, ReasonReact.element(/* None */0, /* None */0, SortEnSeance.make(amendementWrapper[/* sort */15], /* array */[])));
                                              }), $$Array.of_list(List.filter((function (amendement) {
                                                          return +(amendement[/* place */13] === division[/* place */0]);
                                                        }))($$Array.to_list(discussion[/* amendements */0])))));
                            }), discussion[/* divisions */3])
                    ]));
    });
  return newrecord;
}

exports.StringsSetItem = StringsSetItem;
exports.StringsSet = StringsSet;
exports.component = component;
exports.make = make;
/* StringsSet Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/discussionIndex.re
// module id = 1676
// module chunks = 0